import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { verifyPasscode, updatedProtected } from "@registrationaction";
import { classNames } from "@utilscommon";
import LocaleStrings from "@language";
import Loader from "@loader";

import _ from "lodash";
import { renderFieldSelect } from "../../common/base-component";
import { useNavigate } from "react-router-dom";

const CategoryPage = (props) => {
  let { handleSubmit, pristine, invalid, submitting, userCatgegoryData } =
    props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmitForm = (data) => {
    setLoading(true);
    let selected = _.filter(userCatgegoryData, (obj) => {
      return obj.id == data.category;
    });

    navigate(`/register/${selected?.[0]?.formid}`, {
      state: { categoryid: selected?.[0]?.id },
    });
  };
  const categoryOptions = userCatgegoryData
    ? userCatgegoryData
        .filter((cat) => cat.type !== "admin") //  d Exclude admin type
        .map((cat) => ({
          value: cat.id, // or cat.code if API uses a different key
          label: cat.groupname, // text to show in the dropdown
        }))
    : [];

  return !loading ? (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      {/* Title */}
      <div className="text-center text-2xl font-bold text-primary pt-5">
        {LocaleStrings.kChooseYourCategoryText}
      </div>

      {/* Static description */}
      <p className="custom-text-secondary-sm-medium my-6 text-center">
        {LocaleStrings.kCategoryPageDescriptionText}
      </p>

      {/* Form container */}
      <div className={classNames("base-form max-w-xl m-auto")}>
        {/* Dropdown Field */}
        <div className="form-group mb-6">
          <Field
            name={`category`}
            label={LocaleStrings.kSelectCatgoryText}
            component={renderFieldSelect}
            mandatory={true}
            options={categoryOptions}
          />
        </div>

        {/* Submit Button */}
        <div className="text-right">
          <button type="submit" className="theme-button-md">
            {/* Optional loading spinner */}
            {LocaleStrings.kContinueText}
          </button>
        </div>
      </div>
    </form>
  ) : (
    <div className="content-body">
      <Loader />
    </div>
  );
};

const mapStateToProps = (state) => {
  let initVal = {};
  let selected = _.filter(
    state?.userCatgegoryData?.data?.usercategories,
    (obj) => {
      return obj.type === "attendee";
    }
  );
  initVal.category = selected?.[0]?.id;

  return {
    session: state.session,
    userCatgegoryData: state.userCatgegoryData?.data?.usercategories,
    initialValues: initVal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      verifyPasscode,
      updatedProtected,
    },
    dispatch
  );
};

function validate(values) {
  let errors = {};

  // console.log("errors :- ", errors);
  return errors;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "CategoryForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(CategoryPage)
);
